import React from 'react';
import { X } from 'react-feather';
import { Button } from '@components-library/Button';
import { IButtonProps } from '@components-library/Button/Button';
import cn from 'classnames';

export interface IActionButtonProps {
  className: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  id?: string;
  children: string;
  disableButtonAutoPreloader?: boolean;
  showButtonPreloader?: boolean;
  onClick: () => Promise<void> | void;
  testID?: string;
}

const ActionButton = ({
  className,
  disabled,
  type,
  id,
  testID,
  children,
  disableButtonAutoPreloader,
  showButtonPreloader,
  onClick,
}: IButtonProps) => (
  <Button
    className={cn('form__button', className)}
    disabled={disabled}
    type={type}
    id={id}
    testID={testID}
    disableButtonAutoPreloader={disableButtonAutoPreloader}
    showButtonPreloader={showButtonPreloader}
    onClick={onClick}
    errorComponent={
      <span className="form__error">
        <X size={14} />
        <span>Error. Try again</span>
      </span>
    }>
    {children}
  </Button>
);

export default ActionButton;
